/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// this is a timer component which can be used as a timer passed watcher and notifier
module.exports = function () {
    function Timer() {
        var _this = this;

        var topic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Timer.TimePassed';
        var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, _classCallCheck3["default"])(this, Timer);

        this.param = param;
        this.task = null;
        this.topic = topic;
        this.dotTime = new Date().getTime();
        this.uuid = _scope.Utils.Guid();

        _scope.MsgBus.On('timer.stop', function (cb) {
            // 外部关闭当前计时器, 处理用户多次new Player产生的多次计费
            if (typeof cb === 'function' && cb(_this)) {
                _this.stop();
            }
        });
    }

    (0, _createClass3["default"])(Timer, [{
        key: 'start',
        value: function start() {
            this.stop();
            (function (self) {
                self.task = setTimeout(function t() {
                    var duration = self._passedTime();
                    if (duration > 0) {
                        _scope.MsgBus.Pub(self.topic, (0, _extends3["default"])({}, self.param, { duration: duration }));
                    }
                    self.task = setTimeout(t, self.param.timegap || _scope.Utils.GetRandomNum(10, 60) * 1000);
                }, self.param.timegap || _scope.Utils.GetRandomNum(60, 10) * 1000);
            })(this);
        }
    }, {
        key: 'stop',
        value: function stop() {
            if (!this.task) {
                this._passedTime();
                return;
            }
            clearTimeout(this.task);
            this.task = null;
            var duration = this._passedTime();
            if (duration > 0) {
                _scope.MsgBus.Pub(this.topic, (0, _extends3["default"])({}, this.param, { duration: duration }));
            }
        }
    }, {
        key: '_passedTime',
        value: function _passedTime() {
            var passedTime = new Date().getTime() - this.dotTime;
            this.dotTime = new Date().getTime();
            return parseInt(passedTime / 1000);
        }
    }]);
    return Timer;
}();



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/modules/Timer.js
 ** module id = 123
 ** module chunks = 1
 **/